import CellHOC from '@platform/react/hoc/list/cell'
import LabeledHOC from '@platform/react/hoc/list/labeled'
import { ListItemCellTicketRequester } from 'ui/Element/List/Item/Cell/Ticket/Requester'

export default CellHOC(
  LabeledHOC(
    props => props.labels.request, ListItemCellTicketRequester,
  ),
)
